import { ActivityNimReadDTO, ActivityNimUpdateDTO } from '../../api/dto';

export const mapActivityToUpdateDTO = (activity: any): ActivityNimUpdateDTO & ActivityNimReadDTO => {
    return activity;
};
